module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0d9d5b90116fb38324a800a3cbfdd4b8.png";